import { render, staticRenderFns } from "./ConfirmLoginOTP.vue?vue&type=template&id=2fa64c16"
import script from "./ConfirmLoginOTP.vue?vue&type=script&lang=js"
export * from "./ConfirmLoginOTP.vue?vue&type=script&lang=js"
import style0 from "./ConfirmLoginOTP.vue?vue&type=style&index=0&id=2fa64c16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports